var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('issues-card',{attrs:{"issues":_vm.issues,"loading":_vm.isFetching,"errors":_vm.errors},on:{"refresh":function($event){return _vm.refreshIssues()},"save":_vm.onSave,"delete":_vm.onDelete}})}
var staticRenderFns = []

export { render, staticRenderFns }